/**
 * Hub Medical
 * Hub medical Consorcio
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProfileProviderPF } from './profileProviderPF';
import { CouncilProfession } from './councilProfession';


export interface Council { 
    id?: number;
    councilInscriptionNumber?: string;
    councilGroup?: Council.CouncilGroupEnum;
    district?: Council.DistrictEnum;
    councilProfession?: Set<CouncilProfession>;
    firstInscriptionUF?: string;
    councilInscriptionDate?: string;
    councilStatus?: string;
    certifiedHubMedical?: boolean;
    active?: boolean;
    profileProviderPF?: ProfileProviderPF;
}
export namespace Council {
    export type CouncilGroupEnum = 'CRM' | 'COREN' | 'CRO' | 'CRF' | 'CREFITO' | 'CRP' | 'CRBM' | 'CRN' | 'CREF' | 'CREFONO' | 'CRESS' | 'CRMV' | 'CRTR' | 'CRQ' | 'CRBIO';
    export const CouncilGroupEnum = {
        Crm: 'CRM' as CouncilGroupEnum,
        Coren: 'COREN' as CouncilGroupEnum,
        Cro: 'CRO' as CouncilGroupEnum,
        Crf: 'CRF' as CouncilGroupEnum,
        Crefito: 'CREFITO' as CouncilGroupEnum,
        Crp: 'CRP' as CouncilGroupEnum,
        Crbm: 'CRBM' as CouncilGroupEnum,
        Crn: 'CRN' as CouncilGroupEnum,
        Cref: 'CREF' as CouncilGroupEnum,
        Crefono: 'CREFONO' as CouncilGroupEnum,
        Cress: 'CRESS' as CouncilGroupEnum,
        Crmv: 'CRMV' as CouncilGroupEnum,
        Crtr: 'CRTR' as CouncilGroupEnum,
        Crq: 'CRQ' as CouncilGroupEnum,
        Crbio: 'CRBIO' as CouncilGroupEnum
    };
    export type DistrictEnum = 'AC' | 'AL' | 'AP' | 'AM' | 'BA' | 'CE' | 'DF' | 'ES' | 'GO' | 'MA' | 'MT' | 'MS' | 'MG' | 'PA' | 'PB' | 'PR' | 'PE' | 'PI' | 'RJ' | 'RN' | 'RS' | 'RO' | 'RR' | 'SC' | 'SP' | 'SE' | 'TO';
    export const DistrictEnum = {
        Ac: 'AC' as DistrictEnum,
        Al: 'AL' as DistrictEnum,
        Ap: 'AP' as DistrictEnum,
        Am: 'AM' as DistrictEnum,
        Ba: 'BA' as DistrictEnum,
        Ce: 'CE' as DistrictEnum,
        Df: 'DF' as DistrictEnum,
        Es: 'ES' as DistrictEnum,
        Go: 'GO' as DistrictEnum,
        Ma: 'MA' as DistrictEnum,
        Mt: 'MT' as DistrictEnum,
        Ms: 'MS' as DistrictEnum,
        Mg: 'MG' as DistrictEnum,
        Pa: 'PA' as DistrictEnum,
        Pb: 'PB' as DistrictEnum,
        Pr: 'PR' as DistrictEnum,
        Pe: 'PE' as DistrictEnum,
        Pi: 'PI' as DistrictEnum,
        Rj: 'RJ' as DistrictEnum,
        Rn: 'RN' as DistrictEnum,
        Rs: 'RS' as DistrictEnum,
        Ro: 'RO' as DistrictEnum,
        Rr: 'RR' as DistrictEnum,
        Sc: 'SC' as DistrictEnum,
        Sp: 'SP' as DistrictEnum,
        Se: 'SE' as DistrictEnum,
        To: 'TO' as DistrictEnum
    };
}


